export default __webpack_public_path__ + "static/media/loginbg.fad9f6a0.jpg";